import React from 'react';

import { Tooltip, Typography } from 'antd';

import Tag from 'components/Tag';
import { enums } from 'helpers/enums';
import { resolveProductStatus } from 'helpers/functions';
import type { EModerationStatus } from 'v2/interfaces/product';

type ProductStatusTagProps = {
  status: EModerationStatus;
  productType: number;
};

function getStatusTooltipTitle(productStatus: (typeof enums.PRODUCT_STATUS)[string]) {
  if (!productStatus.helpLink) {
    return productStatus.description;
  }

  return (
    <span className='block'>
      {productStatus.description}{' '}
      <Typography.Link
        href={productStatus.helpLink.url}
        target='_blank'
        rel='noopener noreferrer'
        className='text-inherit! underline'
        onClick={event => {
          event.stopPropagation();
        }}
      >
        {productStatus.helpLink.label}
      </Typography.Link>
    </span>
  );
}

export default function ProductStatusTag({ status, productType }: ProductStatusTagProps) {
  const statusCode = resolveProductStatus(status, productType);
  const productStatus = enums.PRODUCT_STATUS[statusCode];

  return (
    <Tooltip title={getStatusTooltipTitle(productStatus)}>
      <div>
        <Tag label={productStatus.label} status={productStatus.status} />
      </div>
    </Tooltip>
  );
}
